<template>
    <div id="data-list-thumb-view" class="data-list-container">
        <div class="vx-col  w-full mb-base">
            <div class="border border-dashed d-theme-border-grey-light rounded relative overflow-hidden items-no-padding" style="background-color: white">
                <div class="vx-row ">
                    <div class="vx-col w-full">
                        <div slot="no-body" class="mt-4" id="products">
                            <vs-table ref="table" noDataText="Nenhuma opção encontrada" search :data="options">
                            
                                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                                    <vs-button type="border" @click="modalOption.visible = true"> <a-icon type="plus" /> NOVA OPÇÃO </vs-button>
                                </div>
                                
                                <template slot="thead">
                                <vs-th>NOME</vs-th>
                                <vs-th width="300">IDENTIFICADOR</vs-th>
                                <vs-th width="30">MIN</vs-th>
                                <vs-th width="30">MAX</vs-th>
                                <vs-th width="30"></vs-th>
                                </template>

                                <template slot-scope="{data}">
                                <tbody>
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    
                                    <vs-td>
                                        <strong class="cursor-pointer pt-6 pb-6" @click="editOption(tr)">
                                          <a-icon type="edit" />
                                          {{ (tr.description || '').toUpperCase() }}
                                        </strong>
                                    </vs-td>
                                    
                                    <vs-td>
                                        <span class="cursor-pointer pt-6 pb-6" @click="editOption(tr)">{{ (tr.alias || '').toUpperCase() }}</span>
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.min }}
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.max }}
                                    </vs-td>
                                    
                                    <vs-td class="whitespace-no-wrap">
                                        <vs-button type="border" @click="removeOption(tr)"> <a-icon type="delete" /></vs-button>
                                    </vs-td>
                                        
                                    </vs-tr>
                                </tbody>
                                </template>
                            </vs-table>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <OptionsAddEdit
          :data="modalOption.optionData"
          :visible="modalOption.visible"
          @close="val => closeModal(val)"
          @saved="option => updateOrAddOption(option)"
        />
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import OptionsAddEdit from './OptionsAddEdit'

    const ref = firebase.firestore()

    export default {
      components : {
        OptionsAddEdit
      },

      data () {
          return {
              options : [],
              modalOption : {
                optionData : {},
                visible : false
              },
              companyId : this.$store.getters.getCompanyID
          }
      },

      mounted () {
        this.getOptionsData()
      },

      methods : {
          async getOptionsData () {
              try {
                  this.$vs.loading()
                  let options = await ref.collection(`/company/${this.companyId}/productOptions/`).get()
                  options.docs.forEach(opt => {
                      this.options.push(opt.data())
                  })
              } catch (err) {
                  this.$error({
                      title: 'Erro',
                      content : `Erro ao carregar opções: ${err.message}`
                  })
              } finally {
                  this.$vs.loading.close()
              }
          },

          updateOrAddOption (option) {
            let iOption = this.options.findIndex(a => a.id == option.id)

            if (iOption >= 0) {
              this.$set(this.options, iOption, option)
            } else {
              this.options.push(option)
            }
          },

          async removeOption (option) {
            let that = this

            this.$confirm({
                zIndex : 999999,
                title: this.$t('confirmYourIntention'),
                content: 'Deseja realmente remover esta opção?',
                okText : 'Sim! Remover opção',
                cancelText : 'Cancelar',
                okType: 'danger',
                async onOk () {
                    try {
                      that.$vs.loading()
                      await ref.collection(`/company/${that.companyId}/productOptions/`).doc(option.id).delete()

                      let iOption = that.options.findIndex(a => a.id == option.id)
                      if(iOption >= 0) 
                        that.$delete(that.options, iOption)

                      that.$notification.success({
                        message: 'Sucesso!',
                        description: 'Opção removida'
                    })
                    } catch (err) {
                      that.$error({
                          title: 'Erro',
                          content : `Erro ao remover opção: ${err.message}`
                      })
                    } finally {
                      that.$vs.loading.close()
                    }
                }
            })
          },

          closeModal (val) {
            this.$set(this.modalOption, 'optionData', {})
            this.$set(this.modalOption, 'visible', val)
          },

          editOption (option) {
            this.$set(this.modalOption, 'optionData', option)
            this.$set(this.modalOption, 'visible', true)
          }
      }
    }
</script>


<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 3px 3px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>